import React, { useCallback, useLayoutEffect } from "react";
import { css } from "glamor";
import { spacing, typographyColors, uiColors } from "../library/theme";
import { IoIosArrowDropdown } from "react-icons/io";
import ReactDOM from "react-dom";

const moveUpDown = css.keyframes({
  "0%, 100%": {
    transform: "translateY(0)",
  },
  "50%": {
    transform: "translateY(-10px)",
  },
});

const questionAlert = css({
  position: "fixed",
  height: 200,
  zIndex: 4,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundImage: `linear-gradient(to top, ${uiColors.backgroundDark} 5%, transparent)`,
  cursor: "pointer",
  pointerEvents: "auto",
});

const alertContent = css({
  paddingTop: spacing.xl,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: spacing.m,
  backgroundImage: `radial-gradient(${uiColors.backgroundDark}, transparent)`,
});

const alertTitle = css({
  color: typographyColors.inverseBody,
});

const arrowClass = css({
  color: uiColors.background,
  animation: `${moveUpDown} 1s linear infinite`,
  background: uiColors.fieldBackground,
  borderRadius: "50%",
  ":hover": {
    animation: "none",
    cursor: "pointer",
  },
});

export default function LessonQuestionAlert(props) {
  const { questionRef } = props;
  const [lmsContainer, setLmsContainer] = React.useState(null);

  const goToQuestion = useCallback(() => {
    if (props.onGoToQuestion) {
      props.onGoToQuestion();
    } else if (questionRef?.current) {
      questionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }, [questionRef, props.onGoToQuestion]);

  useLayoutEffect(() => {
    const container = document.getElementById("LMS");
    if (container) {
      setLmsContainer(container);
    }
  }, []);

  if (!lmsContainer) {
    return null;
  }

  return ReactDOM.createPortal(
    <div
      id="question-alert"
      className={css(questionAlert)}
      onClick={goToQuestion}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          goToQuestion();
        }
      }}
      aria-label="Ir para a questão disponível abaixo"
    >
      <div className={alertContent}>
        <h3 className={alertTitle}>Responda a questão disponível abaixo</h3>
        <IoIosArrowDropdown size={44} className={arrowClass} />
      </div>
    </div>,
    lmsContainer
  );
}
